import DateTimeP from './DateTimeP.mjs';

export default function EventCard({ title, imgSrc, imgAlt, dateTimeOverride, startDate, endDate, startTime, endTime, url }) {
  return (
    <div className="col-md-4">
      <div className="card card-promo">
          <img
            src={imgSrc}
            alt={imgAlt ?? 'Thumbnail image for the ' + title + ' event.'}
            className="img-wrap ratio ratio-5x2 overflow-hidden card-img-top"
          />

        <div className="card-body">
          <h4 className="label-1 text-primary">{title}</h4>

          <DateTimeP
            dateTimeOverride={dateTimeOverride}
            startDate={startDate}
            endDate={endDate}
            startTime={startTime}
            endTime={endTime}
          />

          {url ? <ViewDetails url={url} title={title} /> : null}
        </div>
      </div>
    </div>
  );
}

function ViewDetails({ url, title }) {
  return (
    <a
      href={url}
      title={'Click to view more details about the ' + title + ' event.'}
      className="btn btn-link"
    >
      View Details
    </a>
  );
}
